module.exports = __webpack_public_path__ + "static/img/media_slide1.a3de1ddc.jpg";